import React from 'react';
import classnames from 'classnames';

// Constants
import { QuickStartGuideItems } from '../../QuickStartGuideItems.constants';

// Components
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import QsgTitle from '../QsgTitle';
import QsgStepTempate from '../QsgStepTemplate';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Styles
import './QsgList.scss';

type Props = {
  setActiveStepId: Function;
  toggleIsOpen: Function;
  quickStartGuideData;
};

const QsgList = ({ setActiveStepId, toggleIsOpen, quickStartGuideData }: Props) => {
  const baseClassName = 'QsgList';
  const { tr } = useTranslation();

  const handleItemClick = itemId => {
    setActiveStepId(itemId);
  };

  const handleCloseClcik = () => {
    toggleIsOpen();
  };

  return (
    <QsgStepTempate
      title={
        <QsgTitle
          title={tr('perform.onboarding.qsg.title')}
          postfixButton={
            <WpButton variant="tertiary" color="white" size="sm" onClick={handleCloseClcik}>
              <WpIcon name="times" />
            </WpButton>
          }
        />
      }
      description={tr('perform.onboarding.qsg.list.description')}
    >
      <div className={baseClassName}>
        <div className={`${baseClassName}__list`}>
          {QuickStartGuideItems.map(item => {
            const classes = classnames(
              `${baseClassName}__list__item`,
              quickStartGuideData[item.id] !== undefined && `${baseClassName}__list__item--completed`
            );
            return (
              <div key={item.id}>
                {item.button ? (
                  <WpButton variant="tertiary" size="lg" block onClick={() => handleItemClick(item.id)}>
                    {tr(item.titleKey)}
                  </WpButton>
                ) : (
                  <div className={classes} role="button" onClick={() => handleItemClick(item.id)}>
                    <div className={`${baseClassName}__list__item__icon`}>{item.icon}</div>
                    <div className={`${baseClassName}__list__item__title`}>{tr(item.titleKey)}</div>
                    <WpButton variant="tertiary" size="sm">
                      <WpIcon name="arrow-right" />
                    </WpButton>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </QsgStepTempate>
  );
};

export default QsgList;
